import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, HostListener } from '@angular/core';
import { MenuStateService } from '../../core/services/menu-state.service';
import { Subscription } from 'rxjs';

export interface SortOption {
  label: string;
  value: string;
  sortOrder: 'asc' | 'desc';
}

@Component({
  selector: 'app-sort-filter',
  templateUrl: './sort-filter.component.html',
  styleUrls: ['./sort-filter.component.scss']
})
export class SortFilterComponent implements OnInit, OnDestroy {
  @Input() sortOptions!: SortOption[];
  @Input() selectedSort!: SortOption;
  @Input() componentId: string = 'default-sort-dropdown'; // Unique identifier for this component
  @Input() actionButtonText: string = 'Action'; // Text for the action button
  
  @Output() sortChanged = new EventEmitter<SortOption>();
  @Output() actionButtonClicked = new EventEmitter<void>();
  
  isSortDropdownOpen = false;
  private subscription: Subscription = new Subscription();
  private menuId: string = '';

  constructor(private menuStateService: MenuStateService) { }

  ngOnInit(): void {
    // Initialize selected sort if not provided
    if (!this.selectedSort && this.sortOptions.length > 0) {
      this.selectedSort = this.sortOptions[0];
    }
    
    // Create a unique menu ID for this component
    this.menuId = `sort-dropdown-${this.componentId}`;
    
    // Subscribe to menu close events
    this.subscription = this.menuStateService.closeAllMenus$.subscribe(close => {
      if (close && this.isSortDropdownOpen) {
        this.isSortDropdownOpen = false;
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription when component is destroyed
    this.subscription.unsubscribe();
  }

  toggleSortDropdown(event: Event): void {
    event.stopPropagation(); // Stop event from bubbling up to document
    
    // Use the menu state service to toggle this menu
    this.isSortDropdownOpen = this.menuStateService.toggleMenu(this.menuId);
  }

  setSortOption(option: SortOption): void {
    this.selectedSort = option;
    this.isSortDropdownOpen = false; // Close dropdown after selection
    this.sortChanged.emit(option);
  }

  // Prevent clicks inside the dropdown menu from closing it
  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    // Stop propagation to prevent document click from closing the dropdown
    event.stopPropagation();
  }
}
